module.exports = __webpack_public_path__ + "img/hk_room_floorplan_04_en.2cc4ec13.png";